"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePasscodeRequestV2 = void 0;
var ValidatePasscodeRequestV2 = /** @class */ (function () {
    // request = new Map<string, ValidatePasscodeRequest[]>();
    function ValidatePasscodeRequestV2(validatePasscodeRequest) {
        this.validatePasscode = [];
        // this.request = this.request.set('validatePasscode', validatePasscodeRequest);
        this.validatePasscode = validatePasscodeRequest;
    }
    return ValidatePasscodeRequestV2;
}());
exports.ValidatePasscodeRequestV2 = ValidatePasscodeRequestV2;
//# sourceMappingURL=ValidatePasscodeRequestV2.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/request/ValidatePasscodeRequestV2.js
// module id = 1682
// module chunks = 8